import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  getReportingReasonsError,
  getReportingReasonsSuccess,
  restoreDefaultReasonsError,
  restoreDefaultReasonsSuccess,
  updateReportingReasonsError,
  updateReportingReasonsSuccess,
} from './actions'
import {
  GET_REPORTING_REASONS_ASYNC,
  RESTORE_DEFAULT_REASONS_ASYNC,
  UPDATE_REPORTING_REASONS_ASYNC,
} from './constants'

const getReportingReasonsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      GET_REPORTING_REASONS_ASYNC.INITIATE,
      UPDATE_REPORTING_REASONS_ASYNC.SUCCESS,
      RESTORE_DEFAULT_REASONS_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.customizationO365)
      return true
    })
    .mergeMap(() =>
      api.settings
        .getReportingReasons(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getReportingReasonsSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getReportingReasonsError, error)))
        .takeUntil(action$.ofType(GET_REPORTING_REASONS_ASYNC.CANCEL))
    )

const updateReportingReasonsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_REPORTING_REASONS_ASYNC.INITIATE).mergeMap((action) =>
    api.settings
      .updateReportingReasons(
        store.getState().partnerOptions.selectedCompany?.value,
        action.payload.data
      )
      .mergeMap((response) =>
        Observable.of(
          updateReportingReasonsSuccess(response),
          addToast({ message: 'Reasons were successfully updated' })
        )
      )
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(updateReportingReasonsError, error),
          addToast({ message: error.response?.message, type: 'error' })
        )
      )
      .takeUntil(action$.ofType(UPDATE_REPORTING_REASONS_ASYNC.CANCEL))
  )

const restoreDefaultReasonsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(RESTORE_DEFAULT_REASONS_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .restoreDefaultReasons(store.getState().partnerOptions.selectedCompany?.value)
      .mergeMap((response) =>
        Observable.of(
          restoreDefaultReasonsSuccess(response),
          addToast({ message: 'Reasons were successfully restored to default' })
        )
      )
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(restoreDefaultReasonsError, error),
          addToast({ message: error.response?.message, type: 'error' })
        )
      )
      .takeUntil(action$.ofType(RESTORE_DEFAULT_REASONS_ASYNC.CANCEL))
  )

export default combineEpics(
  getReportingReasonsEpic,
  updateReportingReasonsEpic,
  restoreDefaultReasonsEpic
)
